import React, { useEffect, useState } from 'react';
import { _setAxios } from '../../../lib/Helper';
import { Autocomplete, TextField } from '@mui/material';

async function fetchList() {

  return await _setAxios("setting/dropdown/modul/44")
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        results.push({
          label: row.list,
          value: row.id,
        })
      });

      return results
    })
}

const SelectSumberBantuanLembaga = ({ ...props }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchList().then((newOptions) => {
      setOptions(newOptions);
    });
  }, []);

  if (!options.length) return "Loading..."

  return (
    <Autocomplete
      {...props}
      value={options.find(option => String(option.value) === String(props.value)) || null}
      options={options}
      noOptionsText="Tidak ada data"
      renderInput={(params) => <TextField {...params}
        fullWidth
        label="Sumber bantuan"
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        name="sumber"
        type="text"
        helperText={
          props.errors.sumber ? props.errors.sumber[0] : null
        }
        error={
          props.errors.sumber
        }
      />}
    />
  );
};
export default SelectSumberBantuanLembaga;
